import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import api from "../../services/api";

const ProtectedRoute = ({ children, userType }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const location = useLocation();
  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  useEffect(() => {
    const verifyAuth = async () => {
      // For debugging
      console.log(
        "ProtectedRoute check - Token:",
        token ? "Token exists" : "No token"
      );
      console.log("ProtectedRoute check - Required user type:", userType);
      console.log(
        "ProtectedRoute check - Stored role:",
        localStorage.getItem("role") ||
          sessionStorage.getItem("role") ||
          "No role found"
      );

      if (!token) {
        console.log("No token found - not authorized");
        setAuthorized(false);
        setLoading(false);
        return;
      }

      try {
        // Check all possible storage locations for the role
        const storedRole =
          localStorage.getItem("role") ||
          sessionStorage.getItem("role") ||
          localStorage.getItem("userType") ||
          sessionStorage.getItem("userType");

        console.log("User role from storage:", storedRole || "No role found");

        // If no role is found but token exists, assume minimal access
        if (!storedRole) {
          console.log("WARNING: Token exists but no role found");
          // If specific user type is required, deny access
          if (userType) {
            setAuthorized(false);
          } else {
            // Allow access to non-type specific routes
            setAuthorized(true);
          }
        } else if (userType && storedRole !== userType && !(storedRole === "admin" && userType === "teacher")) {
          console.log("Role mismatch - not authorized for this route");
          setAuthorized(false);
        } else {
          console.log("User authorized for this route");
          setAuthorized(true);
        }
        setLoading(false);

        /* Uncomment when backend is ready
        const response = await api.get("/auth/verify");
        const userData = response.data;
        
        if (userType && userData.role !== userType) {
          setAuthorized(false);
        } else {
          setAuthorized(true);
        }
        */
      } catch (error) {
        console.error("Authentication error:", error);
        setAuthorized(false);
        setLoading(false);
      }
    };

    verifyAuth();
  }, [userType, token]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (!authorized) {
    // Redirect to login while saving the attempted path
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
